import { ModuleHeader } from '../module-header'
import AvailableAssignmentsItem from './available-assignments-item'
import { AvailableAssignmentsGrid } from './available-assignments.style'

const AvailableAssignments = () => {
    return (
        <>
            <ModuleHeader title="AVAILABLE ASSIGNMENTS" />
            <AvailableAssignmentsGrid>
                <AvailableAssignmentsItem />
                <AvailableAssignmentsItem />
                <AvailableAssignmentsItem />
                <AvailableAssignmentsItem />
            </AvailableAssignmentsGrid>
        </>
    )
}

export { AvailableAssignments }
